import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message, notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CreateSectorRequest } from '@/components/ui/Inputs/types/request/sector';

export const useCreateSector = () => {
	const queryClient = useQueryClient();
	return useMutation(({ body }: { body: CreateSectorRequest }) => Api.post('/sector/create', body), {
		onError: (err: any) => {
			notification.error({
				message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries(['sectors']);
			queryClient.invalidateQueries([QUERY_KEYS.GET_SECTORS]);
			message.success(I18n.get('Sector created successfully'));
		}
	});
};
